import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {
  @Input() totalItems: number = 0; // จำนวนทั้งหมดของข้อมูล
  @Input() currentPage: number = 1;
  @Input() itemsPerPage: number = 10; // จำนวนรายการต่อหน้า
  @Output() pageChange = new EventEmitter<any>(); // อีเวนต์สำหรับการเปลี่ยนหน้า

  totalPages: number = 1;
  pages: number[] = [];

  ngOnInit() {
    this.calculatePages();
  }

  ngOnChanges(changes: SimpleChanges) {
    // console.log('changes', changes);
    
    // Detect changes in the inputs and recalculate pages
      this.calculatePages();
  }

  calculatePages() {
    this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
    this.pages = Array.from({ length: this.totalPages??0 }, (_, i) => i + 1);
  }

  checkPagination(page: number) {
    if(this.currentPage <= 3 && page <= 3){
      return true;
    }else{
      return this.currentPage - page < 2 && (page > this.currentPage ? page - this.currentPage == 1 : true)

    }
  }

  gotoPage(event:any) {
    const inputElement = event.target as HTMLInputElement;
    const page = Number(inputElement.value);
    if(page <= this.totalPages) {
      this.currentPage = page;
      this.update()
    }
  }

  changeItemsPerPage() {
    this.currentPage = 1; // Reset to first page when total pages change
    this.update()
  }

  changePage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.update()
    }
  }

  update() {
    this.pageChange.emit({currentPage: this.currentPage, itemsPerPage: Number(this.itemsPerPage) }); // แจ้งพาเรนต์คอม��พเนนต์ว่ามีการเปลี่ยนหน้า
    this.calculatePages();
  }
}